export function page(page) {
    return {
        type: "PAGE_SET",
        page: page,
    }
}
